import { gql } from '@apollo/client';

const GET_ACTIVITY = gql`
  query ($where: ReadActivityWhereInput!) {
    soundOutWords(where: $where) {
      title
      book {
        id
        bookCode
        type
        title
        characters {
          id
          character
          characterType
          characterCase
        }
      }
      pages {
        page {
          id
          pageNumber
        }
        contents {
          src
          description
        }
        words {
          word {
            src
            description
            capitalize
          }
          sounds {
            src
            description
          }
        }
      }
    }
  }
`;
export default GET_ACTIVITY;
